import type { UseVehicleFeatures } from '../useVehicleFeatures.types';

// TODO: Match with the pro table
export const getFeaturesTableFields = (features: UseVehicleFeatures['features']) =>
	features.map(({ label, name }) => ({
		key: name,
		label,
		value: name,
	}));

export const getFeaturesTableSource = (features: UseVehicleFeatures['features']) =>
	features.reduce(
		(acc, { name, price }) => {
			acc[name] = price;
			return acc;
		},
		{} as Record<string, string>,
	);
